<template>
  <el-dialog
    title="Verification Code"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    top="12%"
  >
    <el-input
      v-model="codeValue"
      placeholder="Please enter the verification code"
      @keyup.enter.native="makeCodeHandler"
    ></el-input>
    <p class="errorText">{{ errorValue }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button @click="makeCodeHandler">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { reqVerificationCodeHandler } from "@api/operations";
export default {
  name: "Verifcation",
  data() {
    return {
      dialogVisible: false,
      codeValue: "",
      errorValue: "",
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    /*确定验证 */
    makeCodeHandler() {
      if (this.codeValue == "")
        return (this.errorValue =
          "Please enter the verification code for verification.");
      if (!/^\d+$/.test(this.codeValue))
        return (this.errorValue = "The CAPTCHA you enter must be in a numeric format.");
      this.reqCodeVerifyHandler();
    },
    async reqCodeVerifyHandler() {
      try {
        console.log(
          "this.codeData.id, this.codeValue",
          this.codeData.id,
          this.codeValue
        );
        await reqVerificationCodeHandler(this.codeData.id, this.codeValue);
        this.getList();
        this.dialogVisible = false;
        this.$message.success("Check success!");
      } catch (error) {
        if (error.code == 28005) return;
        // this.$message.error("Check failure!");
        this.errorValue = "Check failure!";
        // this.dialogVisible = false;
        // this.getList();
        console.log("error", error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.errorText {
  color: red;
  margin: 10px;
  margin-left: 15px;
}
:deep(.el-input__inner) {
  width: 410px;
  margin: 0 auto;
}
:deep(.el-input) {
  text-align: center;
}
:deep(.el-button:focus),
:deep(.el-button:hover) {
  color: white;
  background-color: #00c2929a;
}
:deep(.el-select .el-input__inner:focus),
:deep(.el-input__inner:focus) {
  border-color: #00c292 !important;
}
</style>
